import { GizmoManager, Mesh } from 'babylonjs';
import { LAYER_TYPES } from './enums/layer-types.enum';
import { Layer } from './layer.model';
import { Coordinates3 } from './measurements/coordinates';
import { NameTag } from './name-tag.model';

export class CoordinatesLayer implements Layer<CoordinatesLayerData> {
  id: number;
  name: string;
  createdAt: string;
  editedAt: string;
  data: CoordinatesLayerData = {};
  parentId?: number;
  type = LAYER_TYPES.COORDINATES_LAYER;
  isVisible = false;
  isSaved = true;
  description: string;
}
export interface CoordinatesLayerData {
  position?: Coordinates3;
}

export interface ViewerCoordinatesLayer extends CoordinatesLayer {
  sphere?: Mesh;
  gui?: NameTag;
  gizmoManager?: GizmoManager;
  data: CoordinatesLayerData;
}
